import AbstractRouter from './AbstractRouter';
import {IApiRoute} from '../../@interfaces/services/Router';
import ApiRoute from './ApiRoute';
import app from '../../helpers/app';

export default class ApiRouter extends AbstractRouter<IApiRoute> {
    routeConstructor = ApiRoute;

    getRouteByUri(uri: string): IApiRoute | null {
        const url = app('url');

        let matchedRoute = null;
        for (let i = 0; i < this.routes.length; i++) {
            const route = this.routes[i];
            const routeUri = route.getUri();
            if (!routeUri) {
                continue;
            }

            if (uri === routeUri) {
                return route;
            }

            if (!matchedRoute && url.matches(uri, routeUri)) {
                matchedRoute = route;
            }
        }

        return matchedRoute;
    }
}
